import { render, staticRenderFns } from "./BatchRelMthlyTtyStmt.vue?vue&type=template&id=6931c65c&"
import script from "./BatchRelMthlyTtyStmt.vue?vue&type=script&lang=js&"
export * from "./BatchRelMthlyTtyStmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports